import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import styles from './app.module.css';
//import MatrixGif from "./MatrixGif";
import Matrix from "./Matrix/Matrix";
import Glass from "./front_page/Glass/Glass";
import SignUp from "./auth_components/SignUp/SignUp";
import SignIn from "./auth_components/SignIn/SignIn";

//import ResetPassword from "./Playground1/Playground1";
import Sample from "./Playground2/Playground2";

import UpgradePage from "./matrix_page_main_components/Header/UpgradePage/UpgradePage";
import VerifyEmail from './auth_components/VerifyEmail';

import { AuthProvider } from './global_state_components/AuthProvider';
import ProtectedRoute from './global_state_components/ProtectedRoute'; // Import the PrivateRoute component
import { GlobalStateProvider } from './global_state_components/GlobalStateProvider';

import { GoogleOAuthProvider } from '@react-oauth/google';
import toast, { Toaster } from 'react-hot-toast';
import MatrixWithGlassOnTop from './front_page/MatrixWithGlassOnTop';
import Profile from './miscellaneous/Profile/Profile';
import MyProfile from './miscellaneous/MyProfile/MyProfile';
import MyProfileWhenSigningUp from './auth_components/MyProfileWhenSigningUp/MyProfileWhenSigningUp';

import VideoCall from './VideoCall';
import VideoCallPage from "./video_call_page/VideoCallPage";

import ForgotPassword from './auth_components/ForgotPassword/ForgotPassword';
import ResetPassword from './auth_components/ResetPassword/ResetPassword';
import ProfilePhotoCropper from './Playground1/Playground1';



const clientID = process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID;


function App() {
  return (
    <GoogleOAuthProvider clientId={clientID}>
      <AuthProvider>
        <GlobalStateProvider>
          <Router>
            <div>
              <Routes>
                <Route path="/jitsi" element={<VideoCall/>} />
                
                <Route path="/playground1" element={<ProfilePhotoCropper/>} />
                <Route path="/playground2" element={<Sample/>} />
                <Route path="/upgrade" element={<UpgradePage/>} />
                <Route path="/signup" element={<SignUp/>} />
                <Route path="/signin" element={<SignIn/>} />    {/* If already signed in we have to directly show them matrix page.*/}
                <Route path="auth/forgot-password" element={<ForgotPassword/>} />
                <Route path="auth/reset-password" element={<ResetPassword/>} />
                <Route path="/video_call_page" element={<VideoCallPage/>} />
                <Route path="/auth/verify-email" element={<VerifyEmail />} />
                <Route path="/my_profile_when_signing_up" element={<MyProfileWhenSigningUp/>} />
                <Route path="/sample" element={<Sample/>} />

                {/*<Route path="/matrix" element={<Matrix/>} />*/}

                {/*
                <Route
                  path="/matrix"
                  element={<PrivateRoute element={Matrix} />} // Use PrivateRoute here
                />        
                */}    

                <Route
                  path="/matrix"
                  element={
                    <ProtectedRoute>
                      <Matrix />
                    </ProtectedRoute>
                  }
                />
                {/*<Route path="/" element={<div><Matrix/><Glass/></div>} />*/}

                <Route path="/" element={<MatrixWithGlassOnTop/>} />    {/* If authorized renders Matrix without glass.*/}
              </Routes>
              {/*<PrivateRoute path="/matrix" element={<Matrix/>} />*/}       {/* Protect this route */}
            </div>
          </Router>
        </GlobalStateProvider>
      </AuthProvider>
      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          // Define default options
          className: '',
          duration: 5000,
          style: {
            background: '#363636',
            color: '#fff',
          },

          // Default options for specific types
          success: {
            duration: 3000,
            theme: {
              primary: 'green',
              secondary: 'black',
            },
          },
        }}
      />
    </GoogleOAuthProvider>
  );
}

export default App;

